import { render, staticRenderFns } from "./DetailsFoldout.vue?vue&type=template&id=ed361eaa&scoped=true"
import script from "./DetailsFoldout.vue?vue&type=script&lang=ts"
export * from "./DetailsFoldout.vue?vue&type=script&lang=ts"
import style0 from "./DetailsFoldout.vue?vue&type=style&index=0&id=ed361eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed361eaa",
  null
  
)

export default component.exports